import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/:lang(de|en)?', component: { render: h => h('router-view') } },
    { path: '*', redirect: '/de' },
  ],
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  if (!lang || !['de', 'en'].includes(lang)) {
    return next('/de')
  }
  next()
})

export default router
